var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.79,
    height: 128.372,
    viewBox: "0 0 97.79 128.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-434.487 -321.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M530.512,424.118l-3.676-18.4a18.147,18.147,0,0,0-6.217-10.394,14.817,14.817,0,0,0-6.092-3.2l-15.715-4.563a3.424,3.424,0,0,1-2.446-2.891l-.725-6.219a26.813,26.813,0,0,0,9.217-14.486c2.806-.249,4.961-3.37,4.961-7.307,0-3.639-1.828-6.581-4.331-7.209",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M461.143,349.488c-2.432.7-4.194,3.6-4.194,7.17,0,3.933,2.143,7.05,4.944,7.307a26.92,26.92,0,0,0,9.222,14.486l-.719,6.218a3.423,3.423,0,0,1-2.444,2.892l-15.661,4.546a14.825,14.825,0,0,0-6.142,3.214,18.087,18.087,0,0,0-6.221,10.394l-3.676,18.4",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M505.488,349.449s1.3-26.041-22.109-26.041-22.236,26.08-22.236,26.08",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M462.81,338.3a8.364,8.364,0,0,1,4.647-4.015c3.171-1.153,6.726-.231,9.8,1.17,4.434,2.024,8.307,4.4,13.278,4.953a22.761,22.761,0,0,0,13.331-2.173",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M496.2,383.214l-12.818,11.477-12.818-11.477",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M481.324,438.256c.034-1.379.036-2.758.057-4.137.036-2.288.016-4.576.027-6.865a.476.476,0,0,0-.294-.522,10.594,10.594,0,0,1-3.89-3.166,27.1,27.1,0,0,1-1.9-2.69c-.154-.243-.321-.482-.125-.8.081-.13-.015-.29-.082-.426-.384-.78-.759-1.564-1.153-2.339a43.9,43.9,0,0,1-2.181-5.1,39.963,39.963,0,0,1-1.35-4.6,14.132,14.132,0,0,1-.471-3.105,3.842,3.842,0,0,1,.991-2.634,5.489,5.489,0,0,1,3.472-1.711c.376-.055.754-.087,1.132-.127a1.042,1.042,0,0,0,.673-.33,2.237,2.237,0,1,1,2.919,3.318,1.934,1.934,0,0,1-2.666-.216,1.36,1.36,0,0,0-1.4-.421,6.171,6.171,0,0,0-1.64.448A1.792,1.792,0,0,0,472.3,404.9a24.947,24.947,0,0,0,1.118,4.961c.286.937.594,1.867.954,2.777a42.552,42.552,0,0,0,1.8,3.985c.327.629.62,1.276.987,1.885.107.175.2.328.462.288.187-.029.3.141.387.288a21.672,21.672,0,0,0,1.649,2.318,8.394,8.394,0,0,0,2.452,2.216,1.728,1.728,0,0,0,1.743,0,8.908,8.908,0,0,0,2.712-2.5,23.279,23.279,0,0,0,1.332-1.92.772.772,0,0,1,.627-.447c.229-.012.329-.248.432-.423.471-.8.876-1.64,1.271-2.48a45.777,45.777,0,0,0,1.857-4.486,28.227,28.227,0,0,0,1.523-5.879,4.944,4.944,0,0,0-.023-1.61,1.2,1.2,0,0,0-.582-.8,5.75,5.75,0,0,0-2.235-.722,1.346,1.346,0,0,0-1.211.443,2.241,2.241,0,0,1-1.364.625,2.245,2.245,0,1,1,.306-4.448,1.95,1.95,0,0,1,1.086.6,1.756,1.756,0,0,0,1.147.486,6.924,6.924,0,0,1,3.823,1.328,3.564,3.564,0,0,1,1.394,2.8,15.947,15.947,0,0,1-.644,4.584,48.669,48.669,0,0,1-2.328,6.579,39.355,39.355,0,0,1-2.065,4.193c-.135.236-.283.461-.057.737.087.107.016.251-.052.366a22.785,22.785,0,0,1-2.471,3.421,12.275,12.275,0,0,1-2.115,1.94,5.7,5.7,0,0,1-1.135.663c-.452.184-.481.229-.482.71q-.01,5.309-.025,10.619c-.005,1.388-.03,2.776-.058,4.163a5.728,5.728,0,0,1-.481,1.881,9.613,9.613,0,0,1-3.048,4.188,8.67,8.67,0,0,1-4.032,1.883,9.281,9.281,0,0,1-6.778-1.214,10.03,10.03,0,0,1-3.55-3.856,9.409,9.409,0,0,1-.965-4.1c-.051-1.487-.036-2.98-.2-4.46a5.237,5.237,0,0,0-1.372-2.915,6.163,6.163,0,0,0-5.636-2.075,6,6,0,0,0-3.73,1.978c-.136.144-.036.207.045.29a7.088,7.088,0,0,1,1.091,1.347,5.03,5.03,0,0,1-.511,5.8,4.959,4.959,0,0,1-5.593,1.506,4.833,4.833,0,0,1-3.246-3.754,5.028,5.028,0,0,1,3.414-5.845,3.029,3.029,0,0,1,.819-.172,1.067,1.067,0,0,0,.8-.448,13.44,13.44,0,0,1,1.419-1.58,8.971,8.971,0,0,1,4.73-2.312,9.431,9.431,0,0,1,4.908.415,9.778,9.778,0,0,1,4.05,2.9,9.232,9.232,0,0,1,2.039,4.41,9.943,9.943,0,0,1,.113,1.4c.032,1.169.043,2.338.064,3.508a6.224,6.224,0,0,0,4.042,5.683,6.022,6.022,0,0,0,5.956-.851,6.319,6.319,0,0,0,2.33-3.47,3.738,3.738,0,0,0,.112-1.01C481.33,440.276,481.324,439.266,481.324,438.256Zm-26.381-.584a3.459,3.459,0,0,0-3.623-3.543,3.59,3.59,0,0,0-3.368,3.446,3.458,3.458,0,0,0,3.471,3.575A3.419,3.419,0,0,0,454.943,437.672Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M454.129,437.59a2.734,2.734,0,0,1-2.658,2.752,2.692,2.692,0,0,1-.048-5.382A2.688,2.688,0,0,1,454.129,437.59Z",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDoctor);
export default __webpack_public_path__ + "static/media/defaultDoctor.ad0cafcbc8718598fa2a393282b62eeb.svg";
export { ForwardRef as ReactComponent };